import React from 'react';
const points = [{
  emoji: '😰',
  text: 'Llegás al patio sin saber exactamente qué juego o actividad dar hoy'
}, {
  emoji: '⏱️',
  text: 'Tardás horas planificando lo que podrías resolver en minutos'
}, {
  emoji: '🤷',
  text: 'Lluvia o poco espacio: te bloqueás cuando no tenés el gimnasio disponible'
}, {
  emoji: '💸',
  text: 'Sin criterios claros: no sabés cómo evaluar de forma objetiva y profesional'
}, {
  emoji: '😓',
  text: 'Tus alumnos están desmotivados y siempre terminan jugando a lo mismo'
}, {
  emoji: '😩',
  text: 'El domingo a la noche seguís sin tener el lunes preparado'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-98">
      <div className="max-w-3xl mx-auto" data-id="element-99">
        <div className="text-center mb-12" data-id="element-100">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-101">
            👉 ¿Te reconocés en estas situaciones?
          </h2>
          <p className="text-text-sec text-base sm:text-lg" data-id="element-102">
            Si respondés sí a alguna — este pack es para vos
          </p>
        </div>

        <div className="space-y-4 mb-12" data-id="element-103">
          {points.map((point, i) => <div key={i} className="flex items-center gap-4 sm:gap-6 bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light shadow-sm" data-id="element-104">
              <div className="text-3xl sm:text-4xl flex-shrink-0" data-id="element-105">
                {point.emoji}
              </div>
              <p className="text-text-main font-medium text-base sm:text-lg leading-snug" data-id="element-106">
                {point.text}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-107">
          <p className="text-primary font-serif italic text-xl sm:text-2xl font-bold" data-id="element-108">
            Y vos merecés mucho más que eso →
          </p>
        </div>
      </div>
    </section>;
}